import {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useArticles} from "../../hooks/use-articles";
import {formatDate} from "../../helpers/Date";
import {deleteArticle} from "../api/Article";

import Button from "../../сomponents/UI/Buttons/Button";

const ArticlesListPage = () => {
    const navigate = useNavigate();
    const [articles, setArticles] = useState([]);
    const fetchedArticles = useArticles();

    useEffect(() => {
        setArticles(fetchedArticles);
    }, [fetchedArticles]);

    const goToNewArticle = useCallback(() => {
        navigate('/crm/article/new');
    }, [navigate]);

    const goToEditArticle = useCallback((id) => {
        navigate(`/crm/article/edit/${id}`);
    }, [navigate]);

    const deleteArticleHandler = useCallback((id) => {
        try {
            deleteArticle(id);

            setArticles((prevArticles) =>
                prevArticles.filter(article => article.id !== id)
            );
        } catch (err) {
            console.log(err);
        }
    }, [setArticles]);

    return (
        <section>
            <h1>Все статьи</h1>
            <Button onClick={goToNewArticle}>Добавить статью</Button>
            <table className="table table-dark table-striped">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Название</th>
                    <th scope="col">Автор</th>
                    <th scope="col">Дата публикации</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                {articles.map(article => (
                    <tr key={article.id}>
                        <td>{article.id}</td>
                        <td>{article.title}</td>
                        <td>{article.author_name}</td>
                        <td>{formatDate(article.date)}</td>
                        <td><Button onClick={() => goToEditArticle(article.id)}>Изменить</Button></td>
                        <td><Button onClick={() => deleteArticleHandler(article.id)}>Удалить</Button></td>
                    </tr>
                ))}
                </tbody>
            </table>
        </section>
    );
};

export default ArticlesListPage;